import { Pipe, PipeTransform } from '@angular/core';
import { fromStoredDeploymentType, toDisplayDeploymentType } from 'app/records/deployment-type.record';

@Pipe({ name: 'deploymentType' })
export class DeploymentTypePipe implements PipeTransform {

    public transform(value: string): string {
        if (value) {
            const dType = fromStoredDeploymentType.get(value);
            const deploymentType = toDisplayDeploymentType.get(dType);
            return deploymentType;
        }

        return;
    }

}
